"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgCriticalAlert = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#fff", fillOpacity: 0.48, fillRule: "evenodd", d: "M2.32 10.985a1.1 1.1 0 0 1 .769-.318H9.66a1 1 0 0 0 0-2H3.09A3.09 3.09 0 0 0 0 11.749v11.736a3.09 3.09 0 0 0 3.089 3.091h5.164L6.97 30h-.64a1 1 0 0 0 0 2h11.993a1 1 0 0 0 0-2h-.64L16.4 26.576h5.164a3.09 3.09 0 0 0 3.089-3.09v-1.82a1 1 0 1 0-2 0v1.82a1.09 1.09 0 0 1-1.09 1.09H3.09a1.09 1.09 0 0 1-1.09-1.09V11.753c0-.289.116-.565.32-.769m8.034 15.682L9.104 30h6.444l-1.25-3.333z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#fff", fillOpacity: 0.48, fillRule: "evenodd", d: "M5.33 15.333a1 1 0 0 1 1-1h7.329a1 1 0 0 1 0 2h-7.33a1 1 0 0 1-.999-1M5.33 20a1 1 0 0 1 1-1h3.998a1 1 0 0 1 0 2H6.33a1 1 0 0 1-1-1", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#fff", d: "M28.8 4.308h.259a7.382 7.382 0 0 1-6.175 11.6 3.4 3.4 0 0 0 3.274-3.349c.124-3.305-1.795-5.097-4.142-5.865a3.675 3.675 0 0 1 .372 4.189 1.31 1.31 0 0 1-1.396-1.117 2.96 2.96 0 0 0-1.536 2.793 3.35 3.35 0 0 0 2.929 3.325 7.385 7.385 0 0 1-6.606-8.894 7.4 7.4 0 0 1 1.948-3.63l1.677 1.636a9.42 9.42 0 0 1 7.8-4.907 9.38 9.38 0 0 0-.254 6.532z" })));
exports.default = SvgCriticalAlert;
